import { MenuItem, Typography } from '@sanlam-glacier/app-common/components';
import { ReactNode } from 'react';

type ContextMenuItemProps = {
  onClick: () => void;
  label: string;
  icon: ReactNode;
  disabled?: boolean;
};

export const OverviewContextMenuItem = ({
  onClick,
  disabled,
  label,
  icon
}: ContextMenuItemProps) => {
  return (
    <MenuItem
      adornmentStart={() => icon}
      size={MenuItem.SIZE.SMALL}
      onClick={onClick}
      disabled={disabled}
    >
      <Typography
        align={Typography.ALIGN.LEFT}
        variant={Typography.VARIANT.B3}
        color={disabled ? Typography.COLOR.TERTIARY : Typography.COLOR.DEFAULT}
      >
        {label}
      </Typography>
    </MenuItem>
  );
};
